import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles, createUseColoredStyles } from '../../palette';
import decorate from '../../common/utils/decorate';

const ICONS = {
  boxSize: (props) => (
    <svg {...props} viewBox="0 0 16 16" fill="none">
      <path
        d="M15.8532 13.6467L14.3532 12.1467C14.0379 11.8314 13.4999 12.0561 13.4999 12.5001V13.3334H2.66655V2.50008H3.49989C3.94589 2.50008 4.16789 1.96008 3.85322 1.64674L2.35322 0.146744C2.15789 -0.0485892 1.84122 -0.0485892 1.64589 0.146744L0.146553 1.64674C-0.167447 1.96008 0.0545532 2.50008 0.499887 2.50008H1.33322V13.3334H0.666553C0.297887 13.3334 -0.000113432 13.6321 -0.000113432 14.0001C-0.000113432 14.3681 0.297887 14.6667 0.666553 14.6667H1.33322V15.3334C1.33322 15.7014 1.63122 16.0001 1.99989 16.0001C2.36855 16.0001 2.66655 15.7014 2.66655 15.3334V14.6667H13.4999V15.5001C13.4999 15.9461 14.0406 16.1661 14.3532 15.8534L15.8532 14.3534C16.0486 14.1581 16.0486 13.8421 15.8532 13.6467Z"
        fill="currentColor"
      />
      <path
        d="M8.66667 2.66675L13.3333 4.66675L8.66667 6.66675L4 4.66675L8.66667 2.66675Z"
        fill="currentColor"
      />
      <path
        d="M8 7.83143L4 6.11743V10.0001C4 10.1381 4.08467 10.2621 4.21333 10.3114L8 11.7674V7.83143Z"
        fill="currentColor"
      />
      <path
        d="M9.33325 7.83143V11.7674L13.1199 10.3108C13.2486 10.2621 13.3333 10.1381 13.3333 10.0001V6.11743L9.33325 7.83143Z"
        fill="currentColor"
      />
    </svg>
  ),
  location: (props) => (
    <svg {...props} viewBox="0 0 16 16" fill="none">
      <path
        d="M8 0C4.89819 0 2.375 2.55444 2.375 5.65625C2.375 6.75952 2.69458 7.82837 3.29919 8.74658L8 16L12.7008 8.74658C13.3054 7.82837 13.625 6.75952 13.625 5.65625C13.625 2.55444 11.1018 0 8 0ZM8 8.46875C6.4491 8.46875 5.1875 7.20715 5.1875 5.65625C5.1875 4.10535 6.4491 2.8125 8 2.8125C9.5509 2.8125 10.8125 4.10535 10.8125 5.65625C10.8125 7.20715 9.5509 8.46875 8 8.46875Z"
        fill="currentColor"
      />
    </svg>
  ),
  metro: (props) => (
    <svg {...props} viewBox="0 0 15 12" fill="none">
      <path
        d="M7.375 0C3.3 0 0 3.33125 0 7.44375C0 9.675 0.9625 11.1313 0.9625 11.1313H13.7875C13.7875 11.1313 14.75 9.54375 14.75 7.44375C14.75 3.33125 11.45 0 7.375 0ZM13.2437 10.2188L1.53125 10.2125C1.53125 10.2125 0.90625 9.03125 0.90625 7.41875C0.90625 3.8125 3.8125 0.89375 7.4 0.89375C10.9875 0.89375 13.8938 3.8125 13.8938 7.41875C13.8938 9.05 13.2437 10.2188 13.2437 10.2188Z"
        fill="currentColor"
      />
      <path
        d="M9.4625 1.975H9.36875L7.4 5.83125L5.3625 1.9375L2.56875 8.9625H1.85V9.525H5.8V8.9625H5.01875L5.8 6.76875L7.4 9.525L8.9375 6.76875L9.71875 8.9625H8.9375V9.525H12.8563V8.9625H12.175L9.4625 1.975Z"
        fill="currentColor"
      />
    </svg>
  ),
  time: (props) => (
    <svg {...props} viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C3.585 0 0 3.58475 0 8C0 12.4152 3.585 16 8 16C12.415 16 16 12.4152 16 8C16 3.58475 12.415 0 8 0ZM8 1C11.8625 1 15 4.1365 15 8C15 11.8635 11.8625 15 8 15C4.1375 15 1 11.8635 1 8C1 4.1365 4.1375 1 8 1ZM8 2C4.6875 2 2 4.6885 2 8C2 11.3115 4.6875 14 8 14C11.3125 14 14 11.3115 14 8C14 4.6885 11.3125 2 8 2ZM7.5 4.25V8C7.5 8.27625 7.7225 8.5 8 8.5H10.5C10.775 8.5 11 8.276 11 8C11 7.724 10.775 7.5 10.5 7.5H8.5V4.25C8.5 3.974 8.275 3.75 8 3.75C7.725 3.75 7.5 3.974 7.5 4.25Z"
        fill="currentColor"
      />
    </svg>
  ),
  notepadEdit: (props) => (
    <svg {...props} viewBox="0 0 15.5 16.5" fill="none">
      <path
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        d="m 5.058,0.7500076 h 5.521 c 0.0573,0 0.1143,0.00366 0.171,0.011 2.2473,0.15716 3.9924,2.02219 4,4.275 v 6.4289904 c -0.0083,2.3721 -1.9359,4.2894 -4.308,4.285 H 5.058 c -2.37249,0.0044 -4.30028,-1.9135 -4.308,-4.286 V 5.0360076 c 0.00772,-2.37248 1.93551,-4.29043 4.308,-4.286 z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      <path
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        d="m 5.464,3.8790176 -1.49099,1.2 c -0.14403,0.13725 -0.22503,0.32785 -0.2239,0.5268 0.00114,0.19894 0.08432,0.3886 0.2299,0.5242 l 0.963,1.15898 4.02599,4.8410004 c 0.0671,0.078 0.157,0.1329 0.257,0.157 l 2,0.457 c 0.2645,0.015 0.4947,-0.1788 0.525,-0.442 l -0.093,-1.946 c -0.0069,-0.0999 -0.047,-0.1946 -0.114,-0.269 L 7.61,5.3570176 l -1.06,-1.273 c -0.2552,-0.3378 -0.7252,-0.42653 -1.086,-0.205 z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      <path
        fill="currentColor"
        d="m 14.75,5.8259876 c 0.4142,0 0.75,-0.33579 0.75,-0.75 0,-0.41422 -0.3358,-0.75 -0.75,-0.75 z m -4,-0.75 H 10 c 0,0.41421 0.3358,0.75 0.75,0.75 z m 0.75,-4.315 c 0,-0.41422 -0.3358,-0.75 -0.75,-0.75 -0.4142,0 -0.75,0.33578 -0.75,0.75 z m -3.1511,4.72871 c 0.0711,-0.40807 -0.2021,-0.7965 -0.6102,-0.86759 -0.4081,-0.07108 -0.7965,0.2021 -0.8676,0.61016 z m -3.29609,1.05452 c -0.40967,-0.0612 -0.79138,0.22128 -0.85258,0.63098 -0.0612,0.4096 0.22129,0.7914 0.63096,0.8526 z M 14.75,4.3259876 h -4 v 1.5 h 4 z m -3.25,0.75 v -4.315 H 10 v 4.315 z m -4.6289,0.15628 c -0.1495,0.85838 -0.9566,1.44068 -1.81829,1.31195 l -0.22162,1.48358 c 1.66711,0.249 3.22841,-0.8775 3.51771,-2.5381 z"
      />
    </svg>
  ),
  findInPage: (props) => (
    <svg {...props} viewBox="0 0 24 24" fill="none">
      <path
        fill="currentColor"
        d="M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
      />
    </svg>
  ),
  openInNew: (props) => (
    <svg {...props} viewBox="0 0 24 24" fill="none">
      <path
        fill="currentColor"
        d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
      />
    </svg>
  )
};

const useMainStyles = createUseStyles((theme) => ({
  icon: {
    width: 16,
    minWidth: 16,
    height: 16
  }
}));

const useVariantStylesMap = createUseColoredStyles((theme, color) => ({
  normal: {
    color: theme.getColor('icon', color, 'value', null, null, null, 0.8)
  }
}));

const useSizeStyles = createUseStyles((theme) => ({
  xs: {
    width: 8,
    minWidth: 8,
    height: 8
  },

  sm: {
    width: 10,
    minWidth: 10,
    height: 10
  },

  //md: {},

  lg: {
    width: 24,
    minWidth: 24,
    height: 24
  },

  xl: {
    width: 32,
    minWidth: 32,
    height: 32
  },

  xl2: {
    width: 48,
    minWidth: 48,
    height: 48
  }
}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      classes: {
        main: useMainStyles,
        variant: useVariantStylesMap,
        size: useSizeStyles
      }
    };

    static propTypes = {
      variant: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      size: PropTypes.string
    };

    static defaultProps = {
      variant: 'normal',
      color: 'primary'
    };

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const {
        classes,
        variant,
        color,
        size,
        name,
        ...props
      } = this.props;

      const mergedClassName = mergeClassName(
        classes.main.icon,
        variant && (classes.variant[color] ?? classes.variant.basic)[variant],
        size && classes.size[size]
      );

      props.className = mergedClassName;

      return ICONS[name]?.(props);
    }
  }
);
